<template>
  <div class="aboutBg searchPagePd60">
    <div class="aboutWrapper">
      <img class="about" src="../assets/images/dianzishusaoma.png" alt="关于我们">
    </div>
  </div>
</template>
<script>
  import {store} from '../store/store';
  import $ from 'jquery';

  export default {
    name: 'ebooktip',
    components: {
    }
  }
</script>
<style scoped>
  .aboutBg {
    width: 100%;
    background-size: contain!important;
  }
  .aboutWrapper {
    margin: 0 auto;
    padding:41px 31px 158px;
    width: 1000px;
    background: #fff;
  }
  .about {
  }
</style>
